/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * GTM events for widget Search Accounts
 *
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.3.0
 */

import { IGTMOperation } from './index';

export enum EGTMWidgetSearchAccountsInteractionType {
    close = 'close',
    open = 'open',
}

export const onClickWidget = (interactionType: EGTMWidgetSearchAccountsInteractionType): IGTMOperation => ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v268-e2',
    'event_cat': 'ЛС',
    'event_name': 'clickElement',
    'event_param': `Выбрать лицевой счет / ${interactionType}`,
});

export const onSelectAccount = (accountNumber: string): IGTMOperation => ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v268-e3',
    'event_cat': 'ЛС',
    'event_name': 'clickLink',
    'event_param': `Выбран / ${accountNumber}`,
});

export const onFirstSearch = (): IGTMOperation => ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v268-e4',
    'event_cat': 'ЛС',
    'event_name': 'search',
    'event_param': 'Поиск лицевого счета',
});
